module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"review_button_title":"開啟詳細評論彈窗"}}')
  delete Component.options._Ctor
}
